import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const viewStudentDetailsByAadhar = createAsyncThunk('viewStudentDetailsByAadhar', async ({ aadhar_card_number }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: getConfig.API_URL + `student_details_by_aadhaar/${aadhar_card_number}`,
            headers: { "Accept": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const studentDetailsByAadhaarSlice = createSlice({
    name: 'studentDetailsByAadhaar',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(viewStudentDetailsByAadhar.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else {
                state.data = '';
            }
        });
        builder.addCase(viewStudentDetailsByAadhar.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default studentDetailsByAadhaarSlice.reducer;
